export default __webpack_public_path__ + "static/media/kids-plus-helmets.8ce397c5.glb";